import type {
    ControllerProviderType } from "@rosette/royalur_react/src/game/createControllerContext.js";
import {
    createControllerContext,
    useCreateController,
} from "@rosette/royalur_react/src/game/createControllerContext.js";
import { DiceController } from "@rosette/ts/src/business/game/controller/dice/DiceController.js";
import type { DiceDirective } from "@rosette/ts/src/business/game/controller/dice/DiceDirective.js";


function createDiceControllerContext(): {
    DiceControllerProvider: ControllerProviderType;
    useDiceController: () => DiceController;
    useDiceDirective: () => DiceDirective;
} {
    const useCreateDiceController = () => {
        return useCreateController<DiceDirective, DiceController>(
            () => new DiceController(), [],
        );
    };
    const {
        ControllerProvider, useController, useDirective,
    } = createControllerContext<DiceDirective, DiceController>(useCreateDiceController);

    return {
        DiceControllerProvider: ControllerProvider,
        useDiceController: useController,
        useDiceDirective: useDirective,
    };
}

export const {
    DiceControllerProvider, useDiceController, useDiceDirective,
} = createDiceControllerContext();
